import React from "react";

import { StyledResponsiveText } from "@/components";

import { emDash } from "./constants";

export const getYearInString = (year?: number) => {
  if (!year || year < 0) {
    return emDash;
  }

  return year < 2 ? `${year} year` : `${year} years`;
};

export const getWeekInString = (week: string) => `${week} weeks`;

export const TimeUnitRenderer = (
  togetherPart: string,
  breakpointPart?: string,
  options?: {
    [breakpoint: string]: boolean;
  }
) => {
  return togetherPart ? (
    <StyledResponsiveText align="center">
      {togetherPart}
      {options && options[Object.keys(options)[0]] ? " " : <br />}
      {breakpointPart}
    </StyledResponsiveText>
  ) : (
    emDash
  );
};
